<template>
    <div>
        <app-header>
            <template slot="left">
                <router-link to="/konto">
                    <img src="./../assets/images/prev.svg" alt="">
                </router-link>
            </template>
            <template slot="title">Geld auszahlen</template>
        </app-header>
        <div class="container" >
            <div class="row" id="top">
                <div class="col-8">
                    <div class="font-title-normal">Aktuelles Guthaben</div>
                    <div class="font-title-normal">CHF 9542.50</div>
                    <div class="font-tiny">Aktualisiert am 18 Juni 2018</div>
                </div>
                <div class="col-4">
                    <img src="./../assets/images/konto-img.png" alt="">
                </div>
            </div>
            <div id="middle">
                <button class="font-normal col-6 btn-base"
                        :class="{active: comp === 'bank'}"
                        @click="comp = 'bank'">
                    Bank überweisung
                </button>
                <button class="font-normal col-6 btn-base" :class="{active: comp === 'paypal'}"
                        @click="comp = 'paypal'">PayPal
                </button>
            </div>
            <div id="components" class="table-wrapper-scroll-y">
                <div class="row">
                    <form class="form-profil">
                        <app-bank v-if="comp === 'bank'"></app-bank>
                        <app-paypal v-else></app-paypal>
                        <button class="btn-green font-size-btn" @click.prevent="submitted"
                                @click="changeModal(true)">Ausführen
                        </button>
                        <modal :show="showModal" @close="changeModal(false)" class="small-modal">
                            <template slot="image">
                                <img src="./../assets/images/wilkommen.png">
                            </template>
                            <template slot="title">Auszahlung übermittelt!</template>
                            <template slot="desc">Der Betrag von CHF 4500.00 wurde erfolgreich auf das Konto von Max Mustermann übermittelt.
                            </template>
                            <template slot="button">
                                <div class="btn-modal-footer font-size-btn" @click="showModal = false">Schliessen
                                </div>
                            </template>
                        </modal>
                    </form>
                </div>
            </div>
        </div>
        <app-nav></app-nav>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'
  import Bank from '../components/konto/Bank'
  import Paypal from '../components/konto/Paypal'
  import Modal from '../modals/Modal'
  import modals from '../data/modals'
  export default {
    data() {
      return {
        comp: 'bank',
        showModal: modals.konto,
      }
    },
    methods: {
      changeModal(val) {
        modals.konto = val;
        this.showModal = modals.konto;
      },
      submitted(e) {
        e.preventDefault();
      }
    },
    components: {
      appHeader: Header,
      appNav: Nav,
      appBank: Bank,
      appPaypal: Paypal,
      modal: Modal
    }
  }
</script>

<style lang="scss" scoped>
    @import '../styles/app';
    .row{
        padding: 0 18px;
    }
    #top {
        padding-top: 18px;
    }

    #middle {
        padding-top: 20px;
        button {
            padding: 12px;
            display: inline-block;
            text-align: center;
            border: none;
            background: none;
            font-weight: bold;
            border-bottom: 1px solid $color-list-border;
            &.active, &:focus, &:active {
                color: $color-secondary;
                border-bottom: 2px solid $color-secondary;
                outline: none;
            }
        }
    }
    #components {
        button {
            width: 100%;
            padding: 14px;
            margin: 20px 0;
            border-radius: 6px;
        }
    }

    .table-wrapper-scroll-y {
        max-height: 380px;
    }

</style>
